/**
 * Coerce store `formImages` from API (string, double-encoded JSON, object) to string paths.
 */
export function parseFormImageList(raw) {
  let v = raw;
  if (v == null || v === "") return [];
  if (typeof v === "string") {
    try {
      v = JSON.parse(v);
    } catch {
      return v.trim() ? [v.trim()] : [];
    }
    if (typeof v === "string") {
      try {
        v = JSON.parse(v);
      } catch {
        return v.trim() ? [v.trim()] : [];
      }
    }
  }
  if (!Array.isArray(v)) {
    if (v && typeof v === "object") return parseFormImageList(Object.values(v));
    return [];
  }
  return v
    .map((item) => {
      if (typeof item === "string") return item.trim();
      if (item && typeof item === "object") {
        if (typeof item.path === "string") return item.path.trim();
        if (typeof item.url === "string") return item.url.trim();
      }
      return "";
    })
    .filter(Boolean);
}

/**
 * Build absolute URL for static files served by the API (Images/, etc.).
 * Normalizes Windows-style paths and bare `Store/...` legacy paths.
 */
export function apiAssetUrl(baseUrl, relativePath) {
  if (relativePath == null || relativePath === "") return "";
  const s = String(relativePath).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const base = (baseUrl || "").replace(/\/+$/, "");
  let rel = s.replace(/\\/g, "/").replace(/^\/+/, "");
  const lower = rel.toLowerCase();
  if (!lower.startsWith("images/") && /^store\//i.test(rel)) {
    rel = `Images/${rel}`;
  }
  if (!base) return "";
  return `${base}/${rel}`;
}

/** API origin for fetch() and image URLs (trimmed .env; dev default). */
export function getApiBaseUrl() {
  const u = (process.env.REACT_APP_URL || "").trim().replace(/\/+$/, "");
  if (u) return u;
  if (process.env.NODE_ENV === "development") return "http://localhost:8000";
  return "";
}
